import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, DialogContentText, Modal, ModalProps } from '@p81-common/ui';
import CircularProgress from '@mui/material/CircularProgress';
import { ACTIONS_TEXTS, ModalDetails } from '../helpers/config';

interface ConfirmationModalProps {
  modalDetails: ModalDetails;
  open: ModalProps['open'];
  handleConfirmClick: (event?: React.MouseEvent) => void;
  handleCloseClick: (event?: React.MouseEvent) => void;
  isLoading?: boolean;
}

const ConfirmationModal = ({
  modalDetails,
  open,
  handleConfirmClick,
  handleCloseClick,
  isLoading = false
}: ConfirmationModalProps) => {
  const { t } = useTranslation(['activity']);

  return (
    <Modal
      id="confirmationModal"
      open={open}
      dialogActionsProps={{
        children: (
          <>
            <Button
              variant="text"
              color="primary"
              onClick={handleCloseClick}
              disabled={isLoading}
            >
              {t('activity:buttons.CANCEL')}
            </Button>
            <Button
              color="primary"
              onClick={handleConfirmClick}
              disabled={isLoading}
            >
              {isLoading && (
                <CircularProgress size={16} style={{ marginRight: 8 }} />
              )}
              {t('activity:buttons.ROLLOUT')}
            </Button>
          </>
        )
      }}
      dialogContentProps={{
        children: (
          <DialogContentText>
            {t('activity:networkRollout.CONFIRMATION_MODAL_CONTENT', {
              action:
                modalDetails?.action && ACTIONS_TEXTS[modalDetails.action],
              networks: modalDetails?.networks,
              gws: modalDetails?.gws
            })}
          </DialogContentText>
        )
      }}
      dialogTitleProps={{
        children: t('activity:networkRollout.CONFIRMATION_MODAL_TITLE')
      }}
      onClose={handleCloseClick}
    />
  );
};

export default ConfirmationModal;
